module.exports = __webpack_public_path__ + "media/images/porque/art-pague-em-reais-2cff0ccc6ff48a5fe8fb0cd83538d6af.svg";